import React from 'react';
import { Icon } from 'elements';

const Document = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M18.545,4.8h1.636v1.6h-1.636V4.8z M18.545,8h1.636v1.6h-1.636V8z M18.545,11.2h1.636
      v1.6h-1.636V11.2z M18.545,14.4h1.636V16h-1.636V14.4z M18.545,17.6h1.636v1.6h-1.636V17.6z M18.545,20.8h1.636v1.6h-1.636V20.8z
      M16.909,10.4c0,0.442-0.367,0.8-0.818,0.8H7.909c-0.452,0-0.818-0.358-0.818-0.8v-8c0-0.442,0.367-0.8,0.818-0.8h8.182
      c0.452,0,0.818,0.358,0.818,0.8V10.4L16.909,10.4z M16.909,21.6c0,0.442-0.367,0.8-0.818,0.8H7.909c-0.452,0-0.818-0.358-0.818-0.8
      v-8c0-0.442,0.367-0.8,0.818-0.8h8.182c0.452,0,0.818,0.358,0.818,0.8V21.6L16.909,21.6z M3.818,4.8h1.636v1.6H3.818V4.8z M3.818,8
      h1.636v1.6H3.818V8z M3.818,11.2h1.636v1.6H3.818V11.2z M3.818,14.4h1.636V16H3.818V14.4z M3.818,17.6h1.636v1.6H3.818V17.6z
      M3.818,20.8h1.636v1.6H3.818V20.8z M18.545,0H5.455C3.647,0,2.182,1.433,2.182,3.2V24h3.273h13.091h3.273V3.2
      C21.818,1.433,20.353,0,18.545,0L18.545,0z"/>
  </Icon>
);

export default Document;



// WEBPACK FOOTER //
// ./src/core/icons/components/Video.jsx